window.addEventListener('load', function () {
  setTimeout(function () {
    var alerts = document.querySelectorAll('.alert');
    alerts.forEach(function (alert) {
      alert.classList.add('opacity-0');
      setTimeout(function () {
        alert.parentNode.removeChild(alert);
      }, 500);
    });
  }, 5000);
});
